export default function Backdrop() {
    return {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    background: 'rgba(0,0,0,0.5)',
                    '&.MuiBackdrop-invisible': {
                        background: 'transparent'
                    }
                }
            }
        }
    };
}
